export default __webpack_public_path__ + "static/media/favicon_v2.c5339589.svg";